module.exports = __webpack_public_path__ + "static/media/tv.6de508a4.png";